export interface TenderResult {
  source: string;
  name: string;
  description: string;
  url: string;
  publishDate?: string;
  organisationName?: string;
  solicitationNumber?: string;
  deadline?: string;
  estimatedValue?: string;
  category?: string;
  matchedKeyword?: string;
  relevanceScore?: number;
  relevanceReason?: string;
  confidenceScore?: number;
  confidenceBreakdown?: {
    icp: number;
    product: number;
    compliance: number;
    opportunity: number;
    antiPatternPenalty: number;
  };
  summary?: string;
  language?: string;
  screenshotUrl?: string;
}

export interface SavedTender {
  id: string;
  savedAt: string;
  notes?: string;
  tenderId?: string;
  tender: TenderResult;
}

export function tenderKey(t: TenderResult): string {
  return `${t.source}|${t.name}|${t.url}`;
}

export function tenderScore(t: TenderResult): number {
  return t.confidenceScore ?? t.relevanceScore ?? 0;
}
